import React, { useState, useEffect } from "react";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import HeaderSales from "../common/HeaderSales"; // Imported but not used in view
import axios from "axios";
import * as Constants from "../Constants/index";
import { saveAs } from "file-saver";
import swal from "sweetalert";
import moment from "moment";
import Oval from "../../loader/CircleLoade";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import Sidebar from "../common/Sidebar"; // Added Sidebar Import

export default function SalesSuccessQrTransactionReport() {
  const navigate = useNavigate();
  const [searchUser, setSearchUser] = useState("");
  const [totalPages, setTotalPages] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [errors, setErrors] = useState({});
  const [results, setResults] = useState([]);
  const [searchRecord, setSearchRecord] = useState();
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [qrCode, setQrCode] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [isFiltering, setIsFiltering] = useState(false);
  const defaultFilters = {
    searchUser: "",
    searchTerm: "",
    fromDate: "",
    toDate: "",
  };

  console.log("results", results);
  useEffect(() => {
    qrTransReport(
      {
        searchUser,
        searchTerm,
        fromDate,
        toDate,
      },
      currentPage
    );
  }, [currentPage]);

  const qrTransReport = (filters, page = currentPage) => {
    let token = localStorage.getItem("token");
    let UserType = localStorage.getItem("user_type");
    if (!token) {
      navigate("/");
    } else {
      const activeFilters = filters || {
        searchUser,
        searchTerm,
        fromDate,
        toDate,
      };
      const formattedDate = activeFilters.fromDate
        ? moment(activeFilters.fromDate).format("YYYY-MM-DD HH:mm:ss")
        : "";
      const formattedDate2 = activeFilters.toDate
        ? moment(activeFilters.toDate).format("YYYY-MM-DD 23:59:59")
        : "";
      const start = formattedDate.replace(/:/g, "%3A");
      const end = formattedDate2.replace(/:/g, "%3A");
      const searchByQr = activeFilters.searchTerm === "" ? "" : `code=${activeFilters.searchTerm}&`;
      const searchUserN = activeFilters.searchUser === "" ? "" : `mobile=${activeFilters.searchUser}&`;
      const searchFromDate = activeFilters.fromDate === "" ? "" : `start=${start}&`;
      const searchToDate = activeFilters.toDate === "" ? "" : `end=${end}&`;

      if (activeFilters.fromDate !== "" && activeFilters.toDate === "") {
        swal({
          text: "Please select to date",
          icon: "error",
          timer: 2000,
          buttons: false,
        });
        return;
      }
      if (activeFilters.fromDate === "" && activeFilters.toDate !== "") {
        swal({
          text: "Please select from date",
          icon: "error",
          timer: 2000,
          buttons: false,
        });
        return;
      }
      if (
        activeFilters.fromDate !== "" &&
        activeFilters.toDate !== "" &&
        new Date(activeFilters.fromDate) > new Date(activeFilters.toDate)
      ) {
        swal({
          text: "From date should be less than to date",
          icon: "error",
          timer: 2000,
          buttons: false,
        });
        return;
      }
      try {
        setLoading(true);
        axios
          .get(
            Constants.baseUrl +
            `reports/qrTransReport/list?${searchUserN}${searchFromDate}${searchToDate}${searchByQr}userType=MEMBER&status=SUCCESS&limit=${limit}&page=${page}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Accept-Language": localStorage.getItem("langauge"),
                appVersion: Constants.av,
                platform: Constants.pt,
                company: Constants.company,
                program: Constants.program,
              },
            }
          )
          .then((res) => {
            if (res.status === 201) {
              if (res.data.code === 10001 && res.data.output) {
                setResults(res.data.output.results);
                setTotalPages(res.data.output.totalPages);
                setSearchRecord(res.data.output.results);
                setLoading(false);
              } else if (res.data.code === 12002) {
                setLoading(false);
                setSearchRecord(null);
                setTotalPages(0);
              } else {
                swal({
                  text: res.data.msg,
                  icon: "error",
                  timer: 2000,
                  buttons: false,
                });
                setLoading(false);
              }
            } else {
              swal({
                text: res.data.msg,
                icon: "error",
                timer: 2000,
                buttons: false,
              });
              setLoading(false);
            }
          });
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
  };
  const handleSearchQuery = (event) => {
    const input = event.target.value;
    if (/^\d*$/.test(input)) {
      setSearchUser(input);
    }
    if (event.target.value === "") {
      const clearedFilters = {
        searchUser: "",
        searchTerm,
        fromDate,
        toDate,
      };
      if (currentPage === 1) {
        qrTransReport(clearedFilters, 1);
      }
      setCurrentPage(1);
      setSearchRecord();
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      const activeFilters = {
        searchUser,
        searchTerm,
        fromDate,
        toDate,
      };
      if (currentPage === 1) {
        qrTransReport(activeFilters, 1);
      }
      setCurrentPage(1);
    }
  };

  const download = () => {
    let token = localStorage.getItem("token");
    const formattedDate = fromDate
      ? moment(fromDate).format("YYYY-MM-DD HH:mm:ss")
      : "";
    const formattedDate2 = toDate
      ? moment(toDate).format("YYYY-MM-DD 23:59:59")
      : "";
    const start = formattedDate.replace(/:/g, "%3A");
    const end = formattedDate2.replace(/:/g, "%3A");
    const searchByQr = searchTerm === "" ? "" : `code=${searchTerm}&`;
    const searchUserN = searchUser === "" ? "" : `mobile=${searchUser}&`;
    const searchStatus = filterStatus === "" ? "" : `status=${filterStatus}&`;
    const searchFromDate = fromDate === "" ? "" : `start=${start}&`;
    const searchToDate = toDate === "" ? "" : `end=${end}&`;

    if (fromDate === "" && toDate !== "") {
      swal({
        text: "Please select from date",
        icon: "error",
        timer: 2000,
        buttons: false,
      });
      return;
    }
    if (fromDate !== "" && toDate === "") {
      swal({
        text: "Please select to date",
        icon: "error",
        timer: 2000,
        buttons: false,
      });
      return;
    }
    if (
      fromDate !== "" &&
      toDate !== "" &&
      new Date(fromDate) > new Date(toDate)
    ) {
      swal({
        text: "From date should be less than to date",
        icon: "error",
        timer: 2000,
        buttons: false,
      });
      return;
    }

    setLoading(true);

    axios
      .get(
        `${Constants.baseUrl}reports/download/qrTransreport?status=SUCCESS&userType=MEMBER&${searchUserN}${searchByQr}${searchFromDate}${searchToDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("language"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          const fileData = new Blob([res.data], { type: "text/csv" });
          saveAs(fileData, "qrTransactionReports.csv");
        } else {
          swal({
            text: res.data.msg || "An error occurred",
            icon: "error",
            timer: 2000,
            buttons: false,
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        swal({
          text: "An error occurred while downloading the file",
          icon: "error",
          timer: 2000,
          buttons: false,
        });
      });
  };

  const handleFilterStatusChange = (e) => {
    setFilterStatus(e.target.value);
  };

  const paginationTotalPages = Math.max(Number(totalPages) || 0, 1);

  const renderPaginationButton = (label, page, isActive = false, isDisabled = false) => (
    <button
      type="button"
      disabled={isDisabled}
      onClick={() => {
        if (!isDisabled && page !== currentPage) {
          setCurrentPage(page);
        }
      }}
      onMouseEnter={(e) => {
        if (!isActive && !isDisabled) {
          e.currentTarget.style.backgroundColor = "#f5f5f5";
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive && !isDisabled) {
          e.currentTarget.style.backgroundColor = "#fff";
        }
      }}
      style={{
        minWidth: "28px",
        height: "28px",
        padding: "0 8px",
        border: "1px solid #ddd",
        backgroundColor: isActive ? "#1a73e8" : isDisabled ? "#f5f5f5" : "#fff",
        color: isActive ? "#fff" : isDisabled ? "#bdbdbd" : "#337ab7",
        cursor: isDisabled ? "not-allowed" : "pointer",
        fontSize: "12px",
        lineHeight: "26px",
      }}
    >
      {label}
    </button>
  );

  const handleReset = ()=>{
    setSearchUser(defaultFilters.searchUser);
    setSearchTerm(defaultFilters.searchTerm);
    setFromDate(defaultFilters.fromDate);
    setToDate(defaultFilters.toDate);
    if (currentPage === 1) {
      qrTransReport(defaultFilters, 1);
    }
    setCurrentPage(1);
    setIsFiltering(false);
  }
  
  return (
    <>
      {loading ? <Oval /> : null}

      {/* --- SIDEBAR LAYOUT WRAPPER START --- */}
      <div
        style={{
          display: "flex",
          width: "100%",
          minHeight: "100vh",
          backgroundColor: "#f5f7fa",
        }}
      >
        {/* Sidebar Fixed Left */}
        <div style={{ flexShrink: 0 }}>
          <Sidebar />
        </div>

        {/* Content Area Resizable Right */}
        <div
          style={{
            flex: 1,
            padding: "20px",
            overflowX: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="all-single-blog rpt"
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              flex: 1,
            }}
          >
            {/* Tabs */}
            <div className="row">
              <div className="col-md-12 tab mb-20">
                <ul className="nav nav-tabs" role="tablist">
                  <li role="presentation" className="active">
                    <Link to="#Section1" role="tab" data-toggle="tab">
                      Success QR Transaction Report
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Form */}
            <div className="row clearfix mb-15">
              <div className="col-md-3 col-sm-12 col-xs-12">
                <div className="form-group has-float-label style-two">
                  <label>Mobile No. </label>
                  <input
                    className="form-control"
                    placeholder="Mobile no."
                    type="text"
                    maxLength="10"
                    value={searchUser}
                    onChange={handleSearchQuery}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  <input
                    type="button"
                    className="btn login_btn"
                    style={{
                      backgroundColor: "#28a745",
                      color: "white",
                      padding: "5px 18px",
                      fontSize: "12px",
                      borderRadius: "3px",
                      minWidth: "120px",
                    }}
                    value="Search"
                    onClick={() => {
                      const activeFilters = {
                        searchUser,
                        searchTerm,
                        fromDate,
                        toDate,
                      };
                      if (currentPage === 1) {
                        qrTransReport(activeFilters, 1);
                      }
                      setCurrentPage(1);
                    }}
                  />
                  <button
                    type="button"
                    onClick={handleReset}
                    className="btn"
                    style={{
                      backgroundColor: "#7a7979",
                      color: "white",
                      padding: "5px 18px",
                      fontSize: "12px",
                      borderRadius: "3px",
                      minWidth: "120px",
                    }}
                  >
                    Reset
                  </button>
                </div>
              </div>

              <div className="col-md-3 col-sm-12 col-xs-12">
                <div className="form-group has-float-label style-two">
                  <label>QR Details </label>
                  <input
                    className="form-control"
                    placeholder="QR Code"
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-3 col-sm-12 col-xs-12">
                <div className="form-group has-float-label style-two">
                  <label>From Date </label>
                  <DatePicker
                    selected={fromDate}
                    onChange={(date) => setFromDate(date)}
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                    id="Fromdate"
                    showYearDropdown
                    showMonthDropdown
                    autoComplete="off"
                    scrollableYearDropdown
                    maxDate={new Date()}
                  />
                </div>
                {errors.fromDate && (
                  <div className="error-message">{errors.fromDate}</div>
                )}
              </div>
              <div className="col-md-3 col-sm-12 col-xs-12">
                <div className="form-group has-float-label style-two">
                  <label>To Date </label>
                  <DatePicker
                    selected={toDate}
                    onChange={(date) => setToDate(date)}
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                    id="todate"
                    showYearDropdown
                    showMonthDropdown
                    autoComplete="off"
                    scrollableYearDropdown
                    maxDate={new Date()}
                  />
                </div>
                {errors.toDate && (
                  <div className="error-message">{errors.toDate}</div>
                )}
              </div>
            </div>

            {/* Table Container */}
            <div className="row">
              <div className="col-md-12">
                <div className="carrd1" style={{ marginTop: "20px" }}>
                  <div
                    className="card-header card-header-warning"
                    style={{
                      backgroundColor: "#28a745",
                      color: "white",
                      padding: "10px 15px",
                      borderRadius: "4px 4px 0 0",
                    }}
                  >
                    <h4
                      className="card-title"
                      style={{
                        margin: 0,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>Success QR Transaction Report</span>
                      {searchRecord === null ? (
                        ""
                      ) : (
                        <Link
                          to="#"
                          className="pull-right btn btn-sm btn-light"
                          style={{ color: "#28a745", fontWeight: "bold" }}
                          onClick={download}
                        >
                          <i className="fa fa-file-excel-o"></i> Export
                        </Link>
                      )}
                    </h4>
                  </div>
                  <div
                    className="card-body table-responsive"
                    style={{ border: "1px solid #ddd", borderTop: "none" }}
                  >
                    <table
                      className="table table-striped mb_01"
                      id="table-to-xls"
                    >
                      <thead>
                        <tr>
                          <th>S.no</th>
                          <th>Member Name</th>
                          <th>Member Mobile</th>
                          <th>Register Date</th>
                          <th>Register From</th>
                          <th>Sales Name</th>
                          <th>Total Balance Points</th>
                          <th>QR Code</th>
                          <th>Capture QR Create Date</th>
                          <th>Status</th>
                          <th>Remark</th>
                          <th>Scan ID</th>
                          <th>Earning Points</th>
                          <th>Lot</th>
                          <th>qrCodeName</th>
                          <th>skuDetail</th>
                          <th>uom</th>
                          <th>packs</th>
                          <th>weight</th>
                        </tr>
                      </thead>
                      {searchRecord === null ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan="19"
                              style={{
                                textAlign: "center",
                                fontSize: "16px",
                                padding: "20px",
                              }}
                            >
                              No record found!
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {Array.isArray(results) && results.length > 0 ? (
                            results.map((item, index) => {
                              const serialNumber =
                                (currentPage - 1) * limit + index + 1;

                              return (
                                <tr key={index}>
                                  <td>{serialNumber}</td>
                                  <td>{item[0]}</td>
                                  <td>{item[1]}</td>
                                  <td>{item[2]}</td>
                                  <td>{item[3]}</td>
                                  <td>{item[4]}</td>
                                  <td>{item[5]}</td>
                                  <td>{item[6]}</td>
                                  <td>{item[7]}</td>
                                  <td>{item[8]}</td>
                                  <td>{item[9]}</td>
                                  <td>{item[10]}</td>
                                  <td>{item[11]}</td>
                                  <td>{item[12]}</td>
                                  <td>{item[13]}</td>
                                  <td>{item[14]}</td>
                                  <td>{item[15]}</td>
                                  <td>{item[16]}</td>
                                  <td>{item[17]}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td
                                colSpan="19"
                                style={{
                                  textAlign: "center",
                                  fontSize: "16px",
                                  padding: "20px",
                                }}
                              >
                                No data found!
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                    {searchRecord !== null && (
                      <div
                        style={{
                          marginTop: "15px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            borderRadius: "4px",
                            overflow: "hidden",
                            backgroundColor: "#fff",
                          }}
                        >
                          {renderPaginationButton("«", currentPage - 1, false, currentPage === 1)}
                          {Array.from({ length: paginationTotalPages }, (_, index) =>
                            renderPaginationButton(index + 1, index + 1, currentPage === index + 1)
                          )}
                          {renderPaginationButton("»", currentPage + 1, false, currentPage === paginationTotalPages)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
      {/* --- SIDEBAR LAYOUT WRAPPER END --- */}
    </>
  );
}
